import React, { ReactElement } from 'react'
import { Flex, Image, Text } from 'theme-ui'
import { Button, Svg } from 'ui'
import SuccessCheck from 'images/organization/homepage/sections/solutions/success-check.svg'
import { SolutionType } from 'components/HomePage/Header/menus/solutions'
import { DOCS_CONTROL_D_DOMAIN } from 'gatsby-env-variables'
import { navigate } from 'gatsby'

export default function SolutionContainer({
  title,
  subText,
  features,
  url,
  illustration,
  type,
}: {
  title: string
  subText: string
  features: string[]
  url: string
  illustration: string
  type: SolutionType
}): ReactElement {
  return (
    <Flex
      id={type}
      sx={{
        justifyContent: 'center',
        borderRadius: '1.2rem',
        p: ['1.6rem', '4rem'],
        gap: '4rem',
        alignItems: 'center',
        backgroundColor: 'blue80',
        border: '1px solid',
        borderColor: 'wakaiwaGrey50',
        zIndex: 'zIndex1',
      }}
      className="solution-container"
    >
      <Flex
        sx={{
          contentVisibility: 'auto',
          gap: ['3.2rem', '4rem'],
          minWidth: ['none', 'none', '92rem'],
          minHeight: ['none', 'none', '32rem'],
          alignItems: 'center',
        }}
      >
        {illustration && (
          <Image
            alt={`${type}-image`}
            src={illustration}
            sx={{
              width: ['22rem', '38rem'],
              height: 'auto',
              borderRadius: '8px',
              WebkitTransform: 'translateZ(0)',
              contentVisibility: 'auto',
            }}
          />
        )}
        <Flex
          sx={{
            maxWidth: '50rem',
            flexShrink: 1,
            flexDirection: 'column',
            textAlign: ['center', 'initial'],
            fontStyle: 'normal',
            alignSelf: 'flex-start',
          }}
        >
          <Text
            as="h2"
            sx={{
              fontSize: '2.1rem',
              fontWeight: '600',
              lineHeight: '138%',
              color: 'aliceBlue',
              mb: '1.6rem',
            }}
          >
            {title}
          </Text>
          <Text
            sx={{
              fontSize: '1.6rem',
              fontWeight: '400',
              lineHeight: '140%',
              color: 'lightSteelBlue',
            }}
          >
            {subText}
          </Text>
          <Flex
            sx={{
              my: '4rem',
              flexDirection: 'column',
              gap: '1.6rem',
              fontSize: '1.6rem',
            }}
          >
            {features?.map(feature => (
              <Flex
                key={feature}
                sx={{
                  color: 'lightSteelBlue',
                  alignItems: 'center',
                  textAlign: 'left',
                  gap: '0.8rem',
                }}
              >
                <Svg
                  sx={{ flexShrink: 0 }}
                  svg={SuccessCheck}
                  descriptiveText="Checkmark icon for feature"
                />
                <Text>{feature}</Text>
              </Flex>
            ))}
          </Flex>
          <Button
            ariaLabel="Learn more"
            name="Learn more"
            variant="roundedSecondary"
            sx={{
              width: ['100%', 'min-content'],
              whiteSpace: 'nowrap',
            }}
            onClick={() => {
              //TODO: Once all solution items point to internal pages, remove this check and use navigate directly.
              if (url.includes(DOCS_CONTROL_D_DOMAIN)) {
                window.open(url, '_blank', 'noopener, noreferrer')
              } else {
                navigate(url)
              }
            }}
          >
            Learn more
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}
